/*
 * <main-product-sync> — re-syncs variant-scoped display nodes after a
 * client-side variant change.
 *
 * Dawn's product-info.js swaps a fixed list of ids (price, Sku, Inventory, …).
 * The SHEKO PDP renders further variant-scoped surfaces outside that list: the
 * delivery line (sold-out state), the portion-price line, the picker's variant
 * title, and the sticky bar's price/delivery previews. Live kept those fresh
 * with bespoke inline scripts that re-derived state client-side; here the
 * server re-render is the single source of truth — this element only copies
 * the freshly rendered nodes (listed in data-targets, space separated) from
 * the fetched document into the live DOM.
 *
 * Fail-safe: a target missing from either document is skipped, never cleared.
 */
if (!customElements.get('main-product-sync')) {
  customElements.define(
    'main-product-sync',
    class MainProductSync extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) =>
            this.onVariantChange(event)
          );
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onVariantChange(event) {
        const data = event && event.data ? event.data : {};
        if (data.sectionId !== this.dataset.sectionId || !data.html) return;

        (this.dataset.targets || '')
          .split(/\s+/)
          .filter(Boolean)
          .forEach((id) => {
            const source = data.html.getElementById(id);
            const destination = document.getElementById(id);
            if (!source || !destination) return;
            destination.innerHTML = source.innerHTML;
            destination.setAttribute('class', source.getAttribute('class') || '');
          });
      }
    }
  );
}
